import { envs } from '@/config/envs';

/**
 * Get all environment variables for the widget
 */
export function getEnv() {
  // TODO: Adjust this when needed add or remove variables
  return envs;
}
